module.exports = "data:image/png;base64,"


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/share/01home/02qr.png
// module id = Sxfa
// module chunks = 0